var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 37 30",
    width: 37,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.5462.270847c.6175.45502.7492 1.324493.2942 1.942023l-19.4444 26.38893c-.2242.3042-.5627.504-.9374.5531-.3747.0492-.7533-.0564-1.0484-.2925l-13.888891-11.1111c-.5989756-.4792-.696089-1.3532-.216909-1.9522.479179-.599 1.3532-.6961 1.95217-.2169l12.76043 10.2083 18.5872-25.225408c.455-.6175279 1.3244-.749266 1.942-.294245z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCheckWhite);
export default __webpack_public_path__ + "static/media/ico_check_white.c62cdc6880ca341690e900d46fb39482.svg";
export { ForwardRef as ReactComponent };